import UploadFile from "./upload-file";


export default UploadFile;